import React from "react";

import { Skeleton } from "primereact/skeleton";

const TableSkeleton: React.FC = () => {
  return (
    <div className="flex flex-column gap-2">
      <Skeleton height="2.5rem" width="100%" />
      <div className="flex flex-row flex-nowrap gap-2">
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
      </div>
      <div className="flex flex-row flex-nowrap gap-2">
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
        <Skeleton height="2.5rem" width="20%" />
      </div>
    </div>
  );
};

export default TableSkeleton;
